export const LOGICAL_OPERATORS = ["and", "or"]
